export default "__VITE_ASSET__Ctkxv49W__"